import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=39d5f299&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=39d5f299&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d5f299",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d5f299')) {
      api.createRecord('39d5f299', component.options)
    } else {
      api.reload('39d5f299', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=39d5f299&scoped=true", function () {
      api.rerender('39d5f299', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Home.vue"
export default component.exports